<template>
<v-container v-if="!isMobile">
   <nav>
<v-app-bar app>
      <v-toolbar-title><v-breadcrumbs
      :items="items"
      large
    ></v-breadcrumbs></v-toolbar-title>
      <v-spacer></v-spacer>
   <div class="pa-1">
   <v-select
          :items="location"
          item-value="_id"
          label="Location Name"
          v-model="locationItem"
          @change="updateLocation"
          :item-text="
                        (location) => {
                          return (
                              location.result[0].location
                          );
                          }
                        "
          prepend-icon="mdi-map-marker"
          solo
          style="font-size: 15px;"
          hide-details
        ></v-select>
   </div>
 <v-md-date-range-picker
                :presets="presets"
                opens="right"
                @change="updateData"
              >
                <v-card class="pa-3" tile slot="input"
                  ><v-icon color="red darken-2"> mdi-clock-outline </v-icon> <span style="font-size: 15px;">{{ formatDate(values1) }} - </span>
                  <span style="font-size: 15px;" v-if="values2 > Date.now()">Now</span><span style="font-size: 15px;" v-else> {{ formatDate(values2) }}</span>
                </v-card>
              </v-md-date-range-picker>
    </v-app-bar>
  </nav>

  <v-container v-if="waterFlow.length == 0">
    <v-container class="d-flex flex-column justify-space-between align-center">
  <v-img
  centered
  max-height="700"
  max-width="700"
  src="https://www.edgecrm.app/images/no-data.gif"
></v-img>
<p>No Data Please Try Another Location</p>
</v-container>
  </v-container>
        
<v-container v-if="waterFlow.length != 0">
  <v-row>
     <v-col>
<v-row dense>
  <v-col>
 <v-card
    class="mx-auto text-center"
    color="grey"
    dark
    max-width="200"
    max-height="100"
  >

    <v-card-text>
      
      <div style="font-size:15px;color:black;">
       {{(location1[0])}}
      </div>
    </v-card-text>
  </v-card>
    </v-col>
     <v-col>
 <v-card
    class="mx-auto text-center"
    color="white"
    dark
    max-width="200"
    max-height="100"
  >

    <v-card-text>
      <div style="font-size:12px;color:black;">
        Recent Flow Rate
      </div>
      <div style="font-size:18px;color:black;" v-if="value1[0] >= 0">
       {{(value1[0]).toFixed(2)}}<span style="font-size:15px;color:black;">L/min</span>
      </div>
    </v-card-text>
  </v-card>
    </v-col>
   
    <v-col>
 <v-card
    class="mx-auto text-center"
    color="white"
    dark
    max-width="200"
    max-height="100"
  >

    <v-card-text>
      <div style="font-size:12px;color:black;">
        Total Volume
      </div>
      <div style="font-size:18px;color:black;" v-if="value1[0] >= 0">
       {{(value1.reduce((a, b) => a + b, 0)).toFixed(2)}}<span style="font-size:15px;color:black;">L</span>
      </div>
    </v-card-text>
  </v-card>
    </v-col>
</v-row>
    </v-col>
  </v-row>

   <v-row>
     <v-col>
<v-row dense>
  <v-col>
 <v-card
    class="mx-auto text-center"
    color="grey"
    dark
    max-width="200"
    max-height="100"
  >

    <v-card-text>
      
      <div style="font-size:15px;color:black;">
       {{(location2[0])}}
      </div>
    </v-card-text>
  </v-card>
    </v-col>
     <v-col>
 <v-card
    class="mx-auto text-center"
    color="white"
    dark
    max-width="200"
    max-height="100"
  >

    <v-card-text>
      <div style="font-size:12px;color:black;">
        Recent Flow rate
      </div>
      <div style="font-size:18px;color:black;" v-if="value2[0] >= 0">
       {{(value2[0]).toFixed(2)}}<span style="font-size:15px;color:black;">L/min</span>
      </div>
    </v-card-text>
  </v-card>
    </v-col>
    <v-col>
 <v-card
    class="mx-auto text-center"
    color="white"
    dark
    max-width="200"
    max-height="100"
  >

    <v-card-text>
      <div style="font-size:12px;color:black;">
        Total Volume
      </div>
      <div style="font-size:18px;color:black;" v-if="value2[0] >= 0">
       {{(value2.reduce((a, b) => a + b, 0)).toFixed(2)}}<span style="font-size:15px;color:black;">L</span>
      </div>
    </v-card-text>
  </v-card>
    </v-col>
</v-row>
    </v-col>
  </v-row>


   <v-row>
     <v-col>
<v-row dense>
  <v-col>
 <v-card
    class="mx-auto text-center"
    color="grey"
    dark
    max-width="200"
    max-height="100"
  >

    <v-card-text>
      <div style="font-size:15px;color:black;">
       {{(location3[0])}}
      </div>
    </v-card-text>
  </v-card>
    </v-col>
     <v-col>
 <v-card
    class="mx-auto text-center"
    color="white"
    dark
    max-width="200"
    max-height="100"
  >

    <v-card-text>
      <div style="font-size:12px;color:black;">
        Recent Flow Rate
      </div>
      <div style="font-size:18px;color:black;" v-if="value3[0] >= 0">
       {{(value3[0]).toFixed(2)}}<span style="font-size:15px;color:black;">L/min</span>
      </div>
    </v-card-text>
  </v-card>
    </v-col>
    <v-col>
 <v-card
    class="mx-auto text-center"
    color="white"
    dark
    max-width="200"
    max-height="100"
  >

    <v-card-text>
      <div style="font-size:12px;color:black;">
        Total Volume
      </div>
      <div style="font-size:18px;color:black;" v-if="value3[0] >= 0">
       {{(value3.reduce((a, b) => a + b, 0)).toFixed(2)}}<span style="font-size:15px;color:black;">L</span>
      </div>
    </v-card-text>
  </v-card>
    </v-col>
</v-row>
    </v-col>
  </v-row>

   <v-row>
     <v-col>
<v-row dense>
  <v-col>
 <v-card
    class="mx-auto text-center"
    color="grey"
    dark
    max-width="200"
    max-height="100"
  >

    <v-card-text>
      
     <div style="font-size:15px;color:black;">
       {{(location4[0])}}
      </div>
    </v-card-text>
  </v-card>
    </v-col>
     <v-col>
 <v-card
    class="mx-auto text-center"
    color="white"
    dark
    max-width="200"
    max-height="100"
  >

    <v-card-text>
      <div style="font-size:12px;color:black;">
        Recent Flow rate
      </div>
      <div style="font-size:18px;color:black;" v-if="value4[0] >= 0">
       {{(value4[0]).toFixed(2)}}<span style="font-size:15px;color:black;">L</span>
      </div>
    </v-card-text>
  </v-card>
    </v-col>
    
    <v-col>
 <v-card
    class="mx-auto text-center"
    color="white"
    dark
    max-width="200"
    max-height="100"
  >

    <v-card-text>
      <div style="font-size:12px;color:black;">
        Total Volume
      </div>
      <div style="font-size:18px;color:black;" v-if="value4[0] >= 0">
       {{(value4.reduce((a, b) => a + b, 0)).toFixed(2)}}<span style="font-size:15px;color:black;">L</span>
      </div>
    </v-card-text>
  </v-card>
    </v-col>
</v-row>
    </v-col>
  </v-row>

   <v-row>
     <v-col>
<v-row dense>
  <v-col>
 <v-card
    class="mx-auto text-center"
    color="grey"
    dark
    max-width="200"
    max-height="100"
  >

    <v-card-text>
      
      <div style="font-size:15px;color:black;">
       {{(location5[0])}}
      </div>
    </v-card-text>
  </v-card>
    </v-col>
     <v-col>
 <v-card
    class="mx-auto text-center"
    color="white"
    dark
    max-width="200"
    max-height="100"
  >

    <v-card-text>
      <div style="font-size:12px;color:black;">
        Recent Flow Rate
      </div>
      <div style="font-size:18px;color:black;" v-if="value5[0] >= 0">
       {{(value5[0]).toFixed(2)}}<span style="font-size:15px;color:black;">L/min</span>
      </div>
    </v-card-text>
  </v-card>
    </v-col>

    <v-col>
 <v-card
    class="mx-auto text-center"
    color="white"
    dark
    max-width="200"
    max-height="100"
  >

    <v-card-text>
      <div style="font-size:12px;color:black;">
        Total Volume
      </div>
      <div style="font-size:18px;color:black;" v-if="value5[0] >= 0">
       {{(value5.reduce((a, b) => a + b, 0)).toFixed(2)}}<span style="font-size:15px;color:black;">L</span>
      </div>
    </v-card-text>
  </v-card>
    </v-col>
</v-row>
    </v-col>
  </v-row>

   <v-row>
     <v-col>
<v-row dense>
  <v-col>
 <v-card
    class="mx-auto text-center"
    color="grey"
    dark
    max-width="200"
    max-height="100"
  >

    <v-card-text>
      
      <div style="font-size:15px;color:black;">
       {{(location6[0])}}
      </div>
    </v-card-text>
  </v-card>
    </v-col>
     <v-col>
 <v-card
    class="mx-auto text-center"
    color="white"
    dark
    max-width="200"
    max-height="100"
  >

    <v-card-text>
      <div style="font-size:12px;color:black;">
        Recent Flow Rate
      </div>
      <div style="font-size:18px;color:black;" v-if="value6[0] >= 0">
       {{(value6[0]).toFixed(2)}}<span style="font-size:15px;color:black;">L/min</span>
      </div>
    </v-card-text>
  </v-card>
    </v-col>
    <v-col>
 <v-card
    class="mx-auto text-center"
    color="white"
    dark
    max-width="200"
    max-height="100"
  >

    <v-card-text>
      <div style="font-size:12px;color:black;">
        Total Volume
      </div>
      <div style="font-size:18px;color:black;" v-if="value6[0] >= 0">
       {{(value6.reduce((a, b) => a + b, 0)).toFixed(2)}}<span style="font-size:15px;color:black;">L</span>
      </div>
    </v-card-text>
  </v-card>
    </v-col>
</v-row>
    </v-col>
  </v-row>
</v-container>
</v-container>

<v-container v-else>
 <v-row>
      <div class="pa-1">
   <v-select
          :items="location"
          item-value="_id"
          label="Location Name"
          v-model="locationItem"
          @change="updateLocation"
          :item-text="
                        (location) => {
                          return (
                              location.result[0].location
                          );
                          }
                        "
          prepend-icon="mdi-map-marker"
          solo
          style="font-size: 12px;"
          hide-details
        ></v-select>
   </div>
   <v-container>
 <v-md-date-range-picker
                :presets="presets"
                opens="right"
                @change="updateData"
              >
                <v-card class="pa-3" tile slot="input"
                  > <v-icon color="red darken-2"> mdi-clock-outline </v-icon><span style="font-size: 12px;">{{ formatDate(values1) }} - </span>
                  <span style="font-size: 12px;" v-if="values2 > Date.now()">Now</span><span style="font-size: 12px;" v-else> {{ formatDate(values2) }}</span>
                </v-card>
              </v-md-date-range-picker>
   </v-container>
    </v-row>

    <v-container v-if="waterFlow.length == 0">
  <v-container class="d-flex flex-column justify-space-between align-center">
  <v-img
  centered
  max-height="700"
  max-width="400"
  src="https://www.edgecrm.app/images/no-data.gif"
></v-img>
<p style="font-size: 12px;">No Data Please Try Another Location</p>
</v-container>
  </v-container>
        
<v-container v-if="waterFlow.length != 0">
  <v-row>
     <v-col>
<v-row dense>
  <v-col>
 <v-card
    class="mx-auto text-center"
    color="grey"
    dark
    max-width="80"
    max-height="100"
  >

    <v-card-text>
      
      <div style="font-size:10px;color:black;">
       {{(location1[0])}}
      </div>
    </v-card-text>
  </v-card>
    </v-col>
     <v-col>
 <v-card
    class="mx-auto text-center"
    color="white"
    dark
    max-width="80"
    max-height="100"
  >

    <v-card-text>
      <div style="font-size:10px;color:black;">
        Recent Flow Rate
      </div>
      <div style="font-size:12px;color:black;" v-if="value1[0] >= 0">
       {{(value1[0]).toFixed(2)}}<span style="font-size:10px;color:black;">L/min</span>
      </div>
    </v-card-text>
  </v-card>
    </v-col>
    <v-col>
 <v-card
    class="mx-auto text-center"
    color="white"
    dark
    max-width="80"
    max-height="100"
  >

    <v-card-text>
      <div style="font-size:10px;color:black;">
        Total Volume
      </div>
      <div style="font-size:12px;color:black;" v-if="value1[0] >= 0">
       {{(value1.reduce((a, b) => a + b, 0)).toFixed(2)}}<span style="font-size:10px;color:black;">L</span>
      </div>
    </v-card-text>
  </v-card>
    </v-col>
</v-row>
    </v-col>
  </v-row>

   <v-row>
     <v-col>
<v-row dense>
  <v-col>
 <v-card
    class="mx-auto text-center"
    color="grey"
    dark
    max-width="80"
    max-height="100"
  >

    <v-card-text>
      
      <div style="font-size:10px;color:black;">
       {{(location2[0])}}
      </div>
    </v-card-text>
  </v-card>
    </v-col>
     <v-col>
 <v-card
    class="mx-auto text-center"
    color="white"
    dark
    max-width="80"
    max-height="100"
  >

    <v-card-text>
      <div style="font-size:10px;color:black;">
        Recent Flow rate
      </div>
      <div style="font-size:12px;color:black;" v-if="value2[0] >= 0">
       {{(value2[0]).toFixed(2)}}<span style="font-size:10px;color:black;">L/min</span>
      </div>
    </v-card-text>
  </v-card>
    </v-col>
    <v-col>
 <v-card
    class="mx-auto text-center"
    color="white"
    dark
    max-width="80"
    max-height="100"
  >

    <v-card-text>
      <div style="font-size:10px;color:black;">
        Total Volume
      </div>
      <div style="font-size:12px;color:black;" v-if="value2[0] >= 0">
       {{(value2.reduce((a, b) => a + b, 0)).toFixed(2)}}<span style="font-size:10px;color:black;">L</span>
      </div>
    </v-card-text>
  </v-card>
    </v-col>
</v-row>
    </v-col>
  </v-row>


   <v-row>
     <v-col>
<v-row dense>
  <v-col>
 <v-card
    class="mx-auto text-center"
    color="grey"
    dark
    max-width="80"
    max-height="100"
  >

    <v-card-text>
      <div style="font-size:10px;color:black;">
       {{(location3[0])}}
      </div>
    </v-card-text>
  </v-card>
    </v-col>
     <v-col>
 <v-card
    class="mx-auto text-center"
    color="white"
    dark
    max-width="80"
    max-height="100"
  >

    <v-card-text>
      <div style="font-size:10px;color:black;">
        Recent Flow Rate
      </div>
      <div style="font-size:12px;color:black;" v-if="value3[0] >= 0">
       {{(value3[0]).toFixed(2)}}<span style="font-size:10px;color:black;">L/min</span>
      </div>
    </v-card-text>
  </v-card>
    </v-col>
    <v-col>
 <v-card
    class="mx-auto text-center"
    color="white"
    dark
    max-width="80"
    max-height="100"
  >

    <v-card-text>
      <div style="font-size:10px;color:black;">
        Total Volume
      </div>
      <div style="font-size:12px;color:black;" v-if="value3[0] >= 0">
       {{(value3.reduce((a, b) => a + b, 0)).toFixed(2)}}<span style="font-size:10px;color:black;">L</span>
      </div>
    </v-card-text>
  </v-card>
    </v-col>
</v-row>
    </v-col>
  </v-row>

   <v-row>
     <v-col>
<v-row dense>
  <v-col>
 <v-card
    class="mx-auto text-center"
    color="grey"
    dark
    max-width="80"
    max-height="100"
  >

    <v-card-text>
      
     <div style="font-size:10px;color:black;">
       {{(location4[0])}}
      </div>
    </v-card-text>
  </v-card>
    </v-col>
     <v-col>
 <v-card
    class="mx-auto text-center"
    color="white"
    dark
    max-width="80"
    max-height="100"
  >

    <v-card-text>
      <div style="font-size:10px;color:black;">
        Recent Flow rate
      </div>
      <div style="font-size:12px;color:black;" v-if="value4[0] >= 0">
       {{(value4[0]).toFixed(2)}}<span style="font-size:10px;color:black;">L/min</span>
      </div>
    </v-card-text>
  </v-card>
    </v-col>
    <v-col>
 <v-card
    class="mx-auto text-center"
    color="white"
    dark
    max-width="80"
    max-height="100"
  >

    <v-card-text>
      <div style="font-size:10px;color:black;">
        Total Volume
      </div>
      <div style="font-size:12px;color:black;" v-if="value4[0] >= 0">
       {{(value4.reduce((a, b) => a + b, 0)).toFixed(2)}}<span style="font-size:10px;color:black;">L</span>
      </div>
    </v-card-text>
  </v-card>
    </v-col>
</v-row>
    </v-col>
  </v-row>

   <v-row>
     <v-col>
<v-row dense>
  <v-col>
 <v-card
    class="mx-auto text-center"
    color="grey"
    dark
    max-width="80"
    max-height="100"
  >

    <v-card-text>
      
      <div style="font-size:10px;color:black;">
       {{(location5[0])}}
      </div>
    </v-card-text>
  </v-card>
    </v-col>
     <v-col>
 <v-card
    class="mx-auto text-center"
    color="white"
    dark
    max-width="80"
    max-height="100"
  >

    <v-card-text>
      <div style="font-size:10px;color:black;">
        Recent Flow Rate
      </div>
      <div style="font-size:12px;color:black;" v-if="value5[0] >= 0">
       {{(value5[0]).toFixed(2)}}<span style="font-size:10px;color:black;">L/min</span>
      </div>
    </v-card-text>
  </v-card>
    </v-col>
    <v-col>
 <v-card
    class="mx-auto text-center"
    color="white"
    dark
    max-width="80"
    max-height="100"
  >

    <v-card-text>
      <div style="font-size:10px;color:black;">
        Total Volume
      </div>
      <div style="font-size:12px;color:black;" v-if="value5[0] >= 0">
       {{(value5.reduce((a, b) => a + b, 0)).toFixed(2)}}<span style="font-size:10px;color:black;">L</span>
      </div>
    </v-card-text>
  </v-card>
    </v-col>
</v-row>
    </v-col>
  </v-row>

   <v-row>
     <v-col>
<v-row dense>
  <v-col>
 <v-card
    class="mx-auto text-center"
    color="grey"
    dark
    max-width="80"
    max-height="100"
  >

    <v-card-text>
      
      <div style="font-size:10px;color:black;">
       {{(location6[0])}}
      </div>
    </v-card-text>
  </v-card>
    </v-col>
     <v-col>
 <v-card
    class="mx-auto text-center"
    color="white"
    dark
    max-width="80"
    max-height="100"
  >

    <v-card-text>
      <div style="font-size:10px;color:black;">
        Recent Flow Rate
      </div>
      <div style="font-size:12px;color:black;" v-if="value6[0] >= 0">
       {{(value6[0]).toFixed(2)}}<span style="font-size:10px;color:black;">L/min</span>
      </div>
    </v-card-text>
  </v-card>
    </v-col>
    <v-col>
 <v-card
    class="mx-auto text-center"
    color="white"
    dark
    max-width="80"
    max-height="100"
  >

    <v-card-text>
      <div style="font-size:10px;color:black;">
        Total Volume
      </div>
      <div style="font-size:12px;color:black;" v-if="value6[0] >= 0">
       {{(value6.reduce((a, b) => a + b, 0)).toFixed(2)}}<span style="font-size:10px;color:black;">L</span>
      </div>
    </v-card-text>
  </v-card>
    </v-col>
</v-row>
    </v-col>
  </v-row>
</v-container>
</v-container>
</template>

<script>
import Vue from "vue";
import axios from "axios";
import moment from 'moment';
import VueApexCharts from 'vue-apexcharts'

Vue.component("apexchart", VueApexCharts);

export default {
  data: () => ({
    items: [
        {
          text: 'Dashboard',
          disabled: false,
          href: '/',
        },
        {
          text: 'Water Flow',
          disabled: true,
          href: '',
        },
        {
          text: 'Usage By Location',
          disabled: true,
          href: '',
        },
      ],
      values1: moment().subtract(24, "hour"),
      values2: moment().endOf("day"),
      presets: [
        {
          label: "Last 1 Hour",
          range: [moment().subtract(1, "hour"), moment().endOf("day")],
        },
        {
          label: "Last 3 Hour",
          range: [moment().subtract(3, "hour"), moment().endOf("day")],
        },
        {
          label: "Last 12 Hour",
          range: [moment().subtract(12, "hour"), moment().endOf("day")],
        },
        {
          label: "Today",
          range: [moment().startOf("day"), moment().endOf("day")],
        },
        {
          label: "This Week",
          range: [moment().subtract(6, "day"), moment().endOf("day")],
        },
        {
          label: "Last Week",
          range: [moment().subtract(13, "day").startOf("day"), moment().subtract(7, "day").endOf("day")],
        },
        {
          label: "This Month",
          range: [moment().startOf("month").startOf("day"), moment().endOf("month")],
        },
        {
          label: "Last Month",
          range: [moment().subtract(2, "month").startOf("day"), moment().subtract(1, "month").endOf("day")],
        },
      ],
    isMobile: true,
    waterFlow:[],

    value1: [],
    value2: [],
    value3: [],
    value4: [],
    value5: [],
    value6: [],

    location1: [],
    location2: [],
    location3: [],
    location4: [],
    location5: [],
    location6: [],

    location: [],
    locationItem: [],
  }),
  mounted() {
    this.loadsWaterFlow();
    this.loadsLocation();
    this.onResize();
    this.intervalFetchData();
    window.addEventListener("resize", this.onResize, { passive: true });
  },
  methods: {
  intervalFetchData: function () {
    setInterval(() => {    
    this.loadsWaterFlow()
       }, 60000); 
  },
  onResize() {
      this.isMobile = window.innerWidth < 700;
  },
  formatDate(value) {
      return moment(value).format("D MMM YYYY, h:mm:ss a")
  },
  loadsLocation: async function(){
      let apiURL = process.env.VUE_APP_API + "/api/location-water-flow";
      axios.get(apiURL).then(res => {
      this.location = res.data;
      this.locationItem = this.location[0]._id;
      this.loadsWaterFlow();
      }).catch(error => {
      console.log(error)
      });
  },
  loadsWaterFlow: async function(){
    let apiURL = process.env.VUE_APP_API + "/api/water-flow/location/" + this.locationItem + "/" + this.values1.toDate() + '/' + this.values2.toDate();
    axios.get(apiURL).then(res => {
    this.waterFlow = res.data;

    this.value1 = res.data.map((value) => value.fields.waterflow0.value);
    this.value2 = res.data.map((value) => value.fields.waterflow1.value);
    this.value3 = res.data.map((value) => value.fields.waterflow2.value);
    this.value4 = res.data.map((value) => value.fields.waterflow3.value);
    this.value5 = res.data.map((value) => value.fields.waterflow4.value);
    this.value6 = res.data.map((value) => value.fields.waterflow5.value);

    this.location1 = res.data.map((location) => location.fields.waterflow0.locationRemarks);
    this.location2 = res.data.map((location) => location.fields.waterflow1.locationRemarks);
    this.location3 = res.data.map((location) => location.fields.waterflow2.locationRemarks);
    this.location4 = res.data.map((location) => location.fields.waterflow3.locationRemarks);
    this.location5 = res.data.map((location) => location.fields.waterflow4.locationRemarks);
    this.location6 = res.data.map((location) => location.fields.waterflow5.locationRemarks);
    }).catch(error => {
    console.log(error)
    });
  },
  updateData(values){
      this.values1 = values[0];
      this.values2 = values[1];
      this.loadsWaterFlow();
    },
  updateLocation(){
      this.loadsWaterFlow();
    },
  },
  beforeDestroy() {
    if (typeof window !== "undefined") {
      window.removeEventListener("resize", this.onResize, { passive: true });
    }
  },
}
</script>